const FORMAT_LOCALE = 'en-GB'

export { FORMAT_LOCALE }
